module.exports = __webpack_public_path__ + "img/structured-water.1f357844.webp";